import { FC } from 'react';
import AutoMatch from '../AutoMatch';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { AutoMatchProps } from '../AutoMatch/interface';

export interface SearchFormAutoMatchProps
  extends BaseSearchFormItemProps {
  /** 自动匹配参数 */
  autoMatchProps?: AutoMatchProps;
}
/** 自动匹配 */
export const SearchFormAutoMatch: FC<SearchFormAutoMatchProps> = props => {
  const {
    autoMatchProps,
    isDetail,
    testId,
    name,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem name={name} {...resProps} label={label} rules={rules}>
      <AutoMatch
        disabled={isDetail || autoMatchProps?.disabled}
        {...autoMatchProps}
        placeholder={getSelectPlaceholder(label, autoMatchProps, rules)}
        test-id={`${testId}-${name}`}
      />
    </SearchFormItem>
  );
};

SearchFormAutoMatch.displayName = SearchFormItemEnum.SearchFormAutoMatch;

export default SearchFormAutoMatch;
